import { UPDATE_PROFILE, PROFILE, CHANGE_PASSWORD } from "../config";
import { get, patch, post } from "./apiHelper";

export const updateProfile = (organisation) => patch(UPDATE_PROFILE, organisation);

export const fetchProfile = () => get(PROFILE);

export const changePassword = (payload) => post(CHANGE_PASSWORD, payload);
